import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import { LuUsers } from "react-icons/lu";
import { LiaUserEditSolid } from "react-icons/lia";
import useGoogleAuthRedirect from '../../hooks/useGoogleAuthRedirect';

const UserTypePark = () => {
    const { t } = useTranslation();
    useGoogleAuthRedirect()

    const [userType, setUserType] = useState("")
    const navigate = useNavigate()

    const storeData = () => {
        const prevData = JSON.parse(localStorage.getItem('registerData')) || {};
        const updatedData = {
            ...prevData,
            userType: userType,
        };
        localStorage.setItem('registerData', JSON.stringify(updatedData));
        if (prevData.loginStatus == "google_login" || prevData.loginStatus == "line_login") {
            navigate('/park/select-age')
        } else {
            navigate('/park/signup')
        }
    }

    return (
        <>
            <div className="battle-theme2">
                {/* { isLoading && <Loader /> } */}

                <div className='main-content'>
                    <div className='padding login-section'>
                        <div className='container'>
                            <div className='login-box mx-auto'>
                                <h4 className='text-center mb-1'>{t('I’m signing up as a Parent or for Myself')}</h4>
                                <p className='text-center mb-5'>{t('Please Select Type Below')}</p>

                                <div className='d-flex flex-wrap flex-sm-nowrap justify-content-center'>
                                    <Link to="" className='w-100 mb-2' onClick={() => setUserType("parent")}>
                                        <div className={`usertype-box mx-auto text-center ${userType === "parent" ? "active" : ""}`}>
                                            <LuUsers />
                                            <h5 className='mb-0'>{t('PARENT')}</h5>
                                        </div>
                                    </Link>

                                    <Link to="" className='w-100' onClick={() => setUserType("myself")}>
                                        <div className={`usertype-box mx-auto text-center ${userType === "myself" ? "active" : ""}`}>
                                            <LiaUserEditSolid />
                                            <h5 className='mb-0'>{t('MYSELF')}</h5>
                                        </div>
                                    </Link>
                                </div>

                                <div className='mt-5 pt-5'>
                                    {userType !== '' ? (
                                        <button className='btn btn1 btn-border-main w-100 mt-4' onClick={storeData}>
                                            {t('NEXT')}
                                        </button>
                                        ) : (
                                        <button className='btn btn1 btn-border-main w-100 mt-4' disabled>
                                            {t('NEXT')}
                                        </button>
                                    )}
                                </div>

                                <p className='mb-0 text-center mt-5'>{t('Already have an account? Login')} <span className='text-white'><Link to="/park/signin" className='link text-decoration-underline fw-medium'>Login</Link></span></p>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UserTypePark
